/**
 * Process layout — a left-to-right sequence of steps with arrows between them.
 * Every node is a step (in order). Use the `vertical` variant for a top-down flow.
 */
import { paletteColor, tintColor } from '../smartArtUtils';

const PAD = 6;
const SIDE_PAD = 3; // outer left/right padding for the horizontal flow (%) — small so wide containers don't show large side margins
const ARROW_GAP = 5; // space reserved for the connecting arrow (%)

export const layoutProcess = (nodes, theme, variant = 'horizontal') => {
  const boxes = [];
  const connectors = [];
  const n = nodes.length;
  if (!n) return { boxes, connectors };

  const arrowFill = tintColor(paletteColor(theme, 0), 0.45);

  if (variant === 'vertical') {
    const innerH = 100 - PAD * 2;
    const hPct = (innerH - ARROW_GAP * (n - 1)) / n;
    const wPct = 100 - SIDE_PAD * 2;
    const xPct = SIDE_PAD;
    nodes.forEach((node, i) => {
      const yPct = PAD + i * (hPct + ARROW_GAP);
      boxes.push({
        nodeId: node.id,
        xPct, yPct, wPct, hPct,
        shapeType: 'rectangle',
        fill: paletteColor(theme, i),
        textColor: theme.textColor,
      });
      if (i < n - 1) {
        const cx = 50;
        connectors.push({
          x1Pct: cx, y1Pct: yPct + hPct,
          x2Pct: cx, y2Pct: yPct + hPct + ARROW_GAP,
          kind: 'blockArrow',
          fill: arrowFill,
          // Animation reveals a connector with the node it leads into.
          toNodeId: nodes[i + 1].id,
        });
      }
    });
    return { boxes, connectors };
  }

  const innerW = 100 - SIDE_PAD * 2;
  const wPct = (innerW - ARROW_GAP * (n - 1)) / n;
  const hPct = 100 - PAD * 2;
  const yPct = PAD;
  nodes.forEach((node, i) => {
    const xPct = SIDE_PAD + i * (wPct + ARROW_GAP);
    boxes.push({
      nodeId: node.id,
      xPct, yPct, wPct, hPct,
      shapeType: 'rectangle',
      fill: paletteColor(theme, i),
      textColor: theme.textColor,
    });
    if (i < n - 1) {
      const cy = 50;
      connectors.push({
        x1Pct: xPct + wPct, y1Pct: cy,
        x2Pct: xPct + wPct + ARROW_GAP, y2Pct: cy,
        kind: 'blockArrow',
        fill: arrowFill,
        // Animation reveals a connector with the node it leads into.
        toNodeId: nodes[i + 1].id,
      });
    }
  });
  return { boxes, connectors };
};
